import { atom } from 'jotai';
import type { FolderId, ViewModelId, WorkspaceId } from 'balus-common';
import type { ViewModelEntity } from '@view-model/domain/view-model';
import type { Workspace } from '@workspace/domain/workspace';
import type { Folder } from '@workspace/view-model-folder/domain/Folder';
import type { RootFolderTree } from '@workspace/view-model-folder/domain/FolderTree';
import { filterByKeyword } from '../filterByKeyword';
import { sidebarSearchKeywordAtom } from '../sidebarSearchKeywordAtom';
import type { SidebarSearchRecords } from '../SidebarSearchRecords';

const kataSearchWorkspacesAtom = atom<Record<WorkspaceId, Workspace>>({});
const kataSearchFolderTreesAtom = atom<Record<WorkspaceId, RootFolderTree>>({});
const kataSearchFoldersAtom = atom<Record<FolderId, Folder>>({});
const kataSearchViewModelsAtom = atom<Record<ViewModelId, ViewModelEntity>>({});

export const setInitialKataSearchRecordsAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      workspaces: Record<WorkspaceId, Workspace>;
      folderTrees: Record<WorkspaceId, RootFolderTree>;
      folders: Record<FolderId, Folder>;
      viewModels: Record<ViewModelId, ViewModelEntity>;
    }
  ) => {
    set(kataSearchWorkspacesAtom, payload.workspaces);
    set(kataSearchFolderTreesAtom, payload.folderTrees);
    set(kataSearchFoldersAtom, payload.folders);
    set(kataSearchViewModelsAtom, payload.viewModels);
  }
);

export const filteredKataSearchRecordsAtom = atom<SidebarSearchRecords>((get) => {
  const workspaces = get(kataSearchWorkspacesAtom);
  const folderTrees = get(kataSearchFolderTreesAtom);
  const folders = get(kataSearchFoldersAtom);
  const viewModels = get(kataSearchViewModelsAtom);
  const searchKeyword = get(sidebarSearchKeywordAtom);

  if (!searchKeyword) {
    return {
      workspaces: {},
      folderTrees: {},
      folders: {},
      viewModels: {},
    };
  }

  return filterByKeyword(searchKeyword, { workspaces, folderTrees, folders, viewModels });
});
